(function () {
  const SLIDER_SELECTOR =
    'body.viva-homepage #MainContent.viva-home .viva-featured__slider[data-viva-featured-slider]';
  const MOBILE_DRAG_MQ = window.matchMedia('(max-width: 768px)');

  function isMobileDrag() {
    return MOBILE_DRAG_MQ.matches;
  }

  function scrollStep(rail) {
    const card = rail.querySelector('.viva-card');
    if (!card) return Math.round(rail.clientWidth * 0.85);
    const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 16;
    return card.offsetWidth + gap;
  }

  function updateNav(rail, prev, next) {
    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    if (maxScroll <= 2) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= maxScroll - 2;
  }

  function initRailDrag(rail) {
    if (!rail) return;

    if (!rail._vivaDragMqBound) {
      rail._vivaDragMqBound = true;
      MOBILE_DRAG_MQ.addEventListener('change', function () {
        initRailDrag(rail);
      });
    }

    if (!isMobileDrag() || rail.dataset.vivaDragReady === 'true') return;

    rail.dataset.vivaDragReady = 'true';

    let isDown = false;
    let hasDragged = false;
    let lockedAxis = null;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let pointerId = null;

    rail.querySelectorAll('a, img').forEach(function (node) {
      node.setAttribute('draggable', 'false');
    });

    rail.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    rail.addEventListener('pointerdown', function (event) {
      if (!isMobileDrag()) return;
      if (event.button !== undefined && event.button !== 0) return;

      isDown = true;
      hasDragged = false;
      lockedAxis = null;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = rail.scrollLeft;
      rail.classList.add('is-dragging');
      rail.setPointerCapture?.(event.pointerId);
    });

    rail.addEventListener('pointermove', function (event) {
      if (!isDown) return;

      const walkX = event.clientX - startX;
      const walkY = event.clientY - startY;
      const absX = Math.abs(walkX);
      const absY = Math.abs(walkY);

      if (!lockedAxis && (absX > 8 || absY > 8)) {
        lockedAxis = absX >= absY ? 'x' : 'y';
      }

      if (lockedAxis === 'y') {
        endDrag();
        return;
      }

      if (absX > 6) hasDragged = true;

      if (hasDragged) {
        event.preventDefault();
        rail.scrollLeft = startScrollLeft - walkX;
      }
    });

    function endDrag() {
      if (!isDown) return;

      isDown = false;
      lockedAxis = null;
      rail.classList.remove('is-dragging');

      if (
        pointerId !== null &&
        (!rail.hasPointerCapture || rail.hasPointerCapture(pointerId))
      ) {
        rail.releasePointerCapture?.(pointerId);
      }
      pointerId = null;

      if (hasDragged) {
        rail.dataset.vivaDragMoved = 'true';
        window.setTimeout(function () {
          delete rail.dataset.vivaDragMoved;
        }, 80);
      }
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('lostpointercapture', endDrag);

    rail.addEventListener(
      'click',
      function (event) {
        if (rail.dataset.vivaDragMoved === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function initSlider(slider) {
    if (!slider || slider.dataset.vivaSliderReady === 'true') return;

    const rail = slider.querySelector('.viva-featured__grid');
    const prev = slider.querySelector('.viva-featured__nav--prev');
    const next = slider.querySelector('.viva-featured__nav--next');
    if (!rail || !prev || !next) return;

    slider.dataset.vivaSliderReady = 'true';
    initRailDrag(rail);

    const refresh = function () {
      updateNav(rail, prev, next);
    };

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -scrollStep(rail), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      rail.scrollBy({ left: scrollStep(rail), behavior: 'smooth' });
    });

    const onScroll = function () {
      refresh();
      if (slider._vivaScrollTimer) window.clearTimeout(slider._vivaScrollTimer);
      slider._vivaScrollTimer = window.setTimeout(refresh, 120);
    };

    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(refresh);
      ro.observe(rail);
    }

    requestAnimationFrame(refresh);
  }

  function initAll() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var initAllTimer;
  function scheduleInitAll() {
    if (initAllTimer) window.clearTimeout(initAllTimer);
    initAllTimer = window.setTimeout(initAll, 50);
  }

  document.addEventListener('shopify:section:load', scheduleInitAll);
})();
